<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <LearningPlansComponent />
      </main>
    </div>
  </div>
</template>

<script>
import LearningPlansComponent from '@/components/learning-plans/LearningPlansComponent.vue';
import Sidebar from '@/components/SidebarComponent.vue';

export default {
  name: 'LearningPlansView',
  components: {
      Sidebar,
      LearningPlansComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
}
</script>

<style scoped>
</style>
